import React, { useEffect, useState } from 'react';
import { putAxiosResponse } from '../../../services/authApiRoutes/APImethods';
import APIUrls from '../../../services/APIUrls';
import { useParams } from 'react-router-dom';
import { transformBlankToNull } from '../../../services/Util';
import Constants from '../../../Constants';

export default function MemberRequestConfirmationPopup({memberRequestData, requestId, popupStatus, setPageRefresh}) {
  const param = useParams();

  const [requestDetails, setRequestDetails] = useState(null);

  useEffect(() => {
    let details = memberRequestData.find((member) => member.id === requestId)
    if(details) {
        setRequestDetails(details);
    }
  }, [memberRequestData, requestId])

  const hidePopup = () => {
    document.body.classList.remove("modal-open-7");
  };

  const handleMemberRequest = (status) => {
    if (requestDetails) {
      requestDetails.status = status;
      putAxiosResponse(APIUrls.CAMPAIGN_MEMBER_REQUEST_UPDATE(param.id, requestId), transformBlankToNull(requestDetails)).then((res) => {
        setPageRefresh(true);
        hidePopup();
      });
    }
  }

  const renderContent = (message, buttonText, onClick) => (
    <>
      <div className="lightbox-content">
        <p>{message}</p>
      </div>
      <div className="modal-footer flex">
        <button className="btn btn-bold active" onClick={onClick}>
          {buttonText}
        </button>
        <button className="btn btn-bold" onClick={hidePopup}>
          Cancel
        </button>
      </div>
    </>
  );

  const getMessage = (status) => {
    if (requestDetails && requestDetails.user) {
      return Constants.POPUP_MESSAGES[status].replace('{name}', `${requestDetails.user.firstName} ${requestDetails.user.lastName}`);
    }
    return '';
  }

  return (
    <div id="modal-open-7" className="lightbox-panel approved-popup " aria-labelledby="translator-heading" aria-modal="true" role="dialog">
      <div className="inner-lightbox-panel">
        <div className="modal-header flex">
          <strong id='translator-heading'>
            {popupStatus === Constants.ACCEPT ? Constants.ACCEPT_MEMBER_REQUEST
              : popupStatus === Constants.REJECT ? Constants.REJECT_MEMBER_REQUEST
              : ""}
          </strong>
        </div>
        {requestDetails && requestDetails.user && 
            (popupStatus in Constants.POPUP_MESSAGES ? 
                renderContent(getMessage(popupStatus), popupStatus.charAt(0).toUpperCase() + popupStatus.slice(1), () => handleMemberRequest(popupStatus === Constants.ACCEPT ? Constants.ACCEPTED : Constants.REJECTED)) 
                : null)}
      </div>
    </div>
  );
};